datePicker.$inject = ["API_URL", "$http", "$timeout"];

require('eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min.js');

angular.module('calendarApp').directive('datePicker', datePicker);

function datePicker(API_URL, $http, $timeout) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: smooth.calendar_url + '/partials/directives/date-picker.html',
    scope: {
      days: '=',
      daysAvailable: '=',
      chosenDate: '=',
      dateChanged: '='
    },
    link: function link(scope, elem, attrs) {
      var init = function init() {
        $timeout(function () {
          var options = {
            format: 'MMMM Do YYYY',
            focusOnShow: false,
            enabledDates: [],
            useCurrent: false,
            locale: moment.locale(smooth.locale)
          };

          if (scope.chosenDate) {
            options.defaultDate = moment(scope.chosenDate);
          }

          $('.sb-datepicker').datetimepicker(options);
          $('.sb-datepicker').on('dp.change', function (event) {
            event.preventDefault();
            scope.chosenDate = event.date.format('YYYY-MM-DD');
            scope.dateChanged(scope.chosenDate);
            return false;
          });
        }, 0);
      }; // End init


      init();
      scope.$watch('daysAvailable', updatePickerDates);

      function updatePickerDates() {
        if (!scope.daysAvailable || !scope.daysAvailable.length) {
          return;
        }

        var momentDates = [],
            maxSettingsDate = moment().add(smooth.calendarSettings.showcalendardays, 'days').hours(23).minutes(59);

        for (var i = 0; i < scope.daysAvailable.length; i++) {
          if (moment(scope.daysAvailable).isSameOrAfter(maxSettingsDate)) {
            break;
          }

          momentDates.push(moment(scope.daysAvailable[i]));
        } // NB: $timeout is necessary


        $timeout(function () {
          if (!$('.sb-datepicker').data("DateTimePicker")) {
            return;
          }

          $('.sb-datepicker').data("DateTimePicker").enabledDates(momentDates).minDate(moment()).maxDate(moment(scope.daysAvailable[scope.daysAvailable.length - 1]));
        }, 0);
      }
    }
  };
}